import apiClient from "./client";

export const messageApi = {
  getConversations: async () => {
    const response = await apiClient.get("/messages/conversations");
    return response.data;
  },

  getMessages: async (storeRequestId) => {
    const response = await apiClient.get(`/messages/${storeRequestId}`);
    return response.data;
  },

  sendMessage: async (storeRequestId, message, attachment = null) => {
    if (attachment) {
      throw new Error("Attachments are not currently supported in this conversation.");
    }
    const response = await apiClient.post(
      `/messages/${storeRequestId}`,
      { message },
    );
    return response.data;
  },

  markAsRead: async (messageId) => {
    const response = await apiClient.put(`/messages/${messageId}/read`);
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await apiClient.get("/messages/unread/count");
    return response.data;
  },
};
